import React, { useCallback, useEffect, useState } from 'react';
import { listIncludedApps, type IncludedApp } from '../../api/includedAppsApi';
import styles from '../Management.module.css';
import AppIcon from '../Identity/AppIcon';

export default function IncludedApps({ showConfiguration = false }: {showConfiguration?: boolean}): React.ReactElement {
  const [apps, setApps] = useState<IncludedApp[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const load = useCallback(async () => {
    setLoading(true); setError('');
    try { setApps(await listIncludedApps()); }
    catch (e) { setError(e instanceof Error ? e.message : 'Applications could not be loaded.'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { void load(); }, [load]);
  return <section className={styles.section} aria-labelledby="included-apps-heading">
    <div className={styles.sectionHeader}>
      <div><h2 id="included-apps-heading">Included with Skeleton Works</h2>
      <p className={styles.muted}>Applications installed for your workspace.</p></div>
      <button className={styles.button} onClick={() => void load()} disabled={loading}>Refresh applications</button>
    </div>
    {loading && <p role="status">Loading included applications…</p>}
    {error && <p className={styles.error} role="alert">{error}</p>}
    {!loading && !error && apps.length === 0 && <div className={styles.empty}>No included applications are installed yet. They will appear here when your VM administrator installs them.</div>}
    {!error && <div className={styles.grid}>{apps.map(app => <article className={styles.card} key={app.id}>
      <span className={styles.badge}>Included application</span><div className={styles.titleRow}><AppIcon iconPath={app.iconPath}/><h3>{app.name}</h3></div>
      <p className={styles.muted}>{app.description}</p>
      <small className={styles.muted}>Version {app.version}</small>
      <div className={styles.actions}>
        <a className={styles.primary} href={app.launchPath}>Open {app.name}</a>
        {showConfiguration && app.configurationPath && <a className={styles.button} href={app.configurationPath}>Configure</a>}
      </div>
    </article>)}</div>}
  </section>;
}
